export default {
    setHeight: function( dialog, customHeight ) {
        "use strict";
        let windowHeight = ( $( window ).height() - 180 );

        // added customHeight so that you can also spcify your own modal height
        if ( typeof customHeight !== 'undefined' ) {
            windowHeight = customHeight;
        }

        dialog.$modalBody.css( "height", windowHeight );
        dialog.$modalBody.slimScroll({
            height: windowHeight + "px",
            color: "rgba(0,0,0,0.5)",
            size: "9px",
            alwaysVisible: true,
            railVisible: true,
            borderRadius: "7px",
            railBorderRadius: "7px"
        });
    },

    setSomeElementHeight: function( $el ) {
        "use strict";
        let windowHeight = ( $( window ).height() - 180 ),
            $content = $el;

        $content.css( "height", windowHeight - 210 );
        $content.slimScroll({
            height: windowHeight - 210 + "px",
            color: "rgba(0,0,0,0.5)",
            size: "9px",
            alwaysVisible: true,
            railVisible: true,
            borderRadius: "7px",
            railBorderRadius: "7px"
        });
    }
};
